import o from"vue";var e=o.observable({colorMode:void 0,theme:void 0,icons:void 0});export{e as c};
